import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiUri, filterRequest } from "../../utilities/apiManager";
import axios from "axios";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getGeneralExpenses = createAsyncThunk(
  "generalExpenses/getGeneralExpenses",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axios.get(
        `${apiUri}/general_expenses?page=${page}&size=${size}&query=${query}${filter}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": document.documentElement.lang,
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createGeneralExpense = createAsyncThunk(
  "generalExpenses/createGeneralExpense",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.post(
        `${apiUri}/general_expenses`,
        args,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Content-Type": "multipart/form-data",
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateGeneralExpense = createAsyncThunk(
  "generalExpenses/updateGeneralExpense",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.put(
        `${apiUri}/general_expenses/${args._id}`,
        args.values,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Content-Type": "multipart/form-data",
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteGeneralExpense = createAsyncThunk(
  "generalExpenses/deleteGeneralExpense",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.delete(
        `${apiUri}/general_expenses/${args._id}`,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const generalExpensesSlice = createSlice({
  name: "generalExpenses",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getGeneralExpenses.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getGeneralExpenses.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getGeneralExpenses.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createGeneralExpense.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createGeneralExpense.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createGeneralExpense.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateGeneralExpense.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateGeneralExpense.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateGeneralExpense.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteGeneralExpense.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteGeneralExpense.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteGeneralExpense.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default generalExpensesSlice.reducer;